import React, { Fragment, useEffect, useContext } from "react";
import UserContext from "../../context/userContext";

const GoogleTagManager = (props) => {
  const { children } = props;

  const hostname = document.location.hostname;

  const userContext = useContext(UserContext);
  const userId = userContext.me.user?.id;
  const userEmail = userContext.me.user?.email;

  const gtmEnvKeys = {
    localhost: "GTM-MKRHVKQD",
    "script.dev.prodconteudo.globoi.com": "GTM-MKRHVKQD",
    "script.qua.prodconteudo.globoi.com": "GTM-MKRHVKQD",
    "script.g.globo": "GTM-MJ72FF2N",
  };

  const initializeGTM = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      user_id: userId,
      user_email: userEmail,
    });

    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(
      window,
      document,
      "script",
      "dataLayer",
      gtmEnvKeys[hostname] || gtmEnvKeys["script.dev.prodconteudo.globoi.com"]
    );
  };

  useEffect(() => {
    if (userId) initializeGTM();
  });

  return (
    <Fragment>
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${
            gtmEnvKeys[hostname] || gtmEnvKeys
          }`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="gtm"
        ></iframe>
      </noscript>

      {children}
    </Fragment>
  );
};

export default GoogleTagManager;
